import { render, staticRenderFns } from "./hellingshoek-van-dak.vue?vue&type=template&id=4d4eaa9c"
import script from "./hellingshoek-van-dak.vue?vue&type=script&lang=js"
export * from "./hellingshoek-van-dak.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports